export const workspacePl = {
  workspace: {
    nav: {
      section: 'Workspace',
      chat: 'Czat',
      settings: 'Ustawienia',
      workspaceSettings: 'Ustawienia workspace',
      memory: 'Pamięć',
      knowledge: 'Wiedza',
      wiki: 'Wiki',
    },
    chat: {
      title: 'Czat',
      subtitle: 'Pytaj agentów workspace o repozytoria, pocztę lub cokolwiek innego',
      empty: 'Wybierz agenta i zadaj pytanie — GitHub, Gmail, pamięć lub ogólny czat.',
      welcomeTitle: 'W czym mogę Ci dzisiaj pomóc?',
      thinking: 'Myślę…',
      analyzing: 'Analizuje…',
      preparing: 'Przygotowuję odpowiedź…',
      callingTool: 'Wywołuję {tool}…',
      processingResult: 'Przetwarzam wynik…',
      loadingSession: 'Ładowanie sesji…',
      placeholder: 'np. Pokaż otwarte PR w org/repo',
      placeholderShort: 'Zadaj pytanie…',
      send: 'Wyślij',
      newChat: 'Nowy czat',
      showSessions: 'Sesje',
      copyBlock: 'Kopiuj',
      copied: 'Skopiowano do schowka',
      copyFailed: 'Nie udało się skopiować',
      errors: {
        genericTitle: 'Coś poszło nie tak',
        genericDescription: 'Asystent nie mógł dokończyć żądania. Spróbuj ponownie lub sprawdź ustawienia workspace.',
        dismiss: 'Zamknij',
        emptyResponseTitle: 'Brak odpowiedzi',
        emptyResponse: 'Asystent nie zwrócił wiadomości. Wyślij pytanie ponownie.',
        streamFailedTitle: 'Błąd połączenia',
        streamFailed: 'Strumień odpowiedzi został przerwany lub nie można go odczytać. Spróbuj ponownie.',
        byok: {
          title: 'Wymagany klucz API OpenRouter',
          description: 'W planie darmowym potrzebujesz własnego klucza API OpenRouter, aby korzystać z czatu AI. Dodaj go w ustawieniach rozliczeń lub ulepsz plan.',
          cta: 'Otwórz rozliczenia',
        },
        usageLimit: {
          title: 'Osiągnięto limit użycia',
          description: 'Wykorzystałeś miesięczny limit AI. Ulepsz plan lub poczekaj na reset limitu.',
          cta: 'Zobacz plany',
        },
      },
    },
    agent: {
      selectLabel: 'Agent',
      selectPlaceholder: 'Wybierz agenta',
      loadError: 'Nie udało się wczytać agentów',
      lockedHint: 'Agent jest stały w tej rozmowie. Zacznij nowy czat, aby zmienić.',
    },
    attachments: {
      attach: 'Dołącz plik',
      remove: 'Usuń załącznik',
      preview: 'Podgląd obrazu',
      visionRequired: 'Wybierz model z obsługą obrazów, aby dołączać zdjęcia',
      kinds: {
        image: 'Obraz',
        text: 'Tekst',
        pdf: 'PDF',
      },
      errors: {
        unsupportedType: 'Nieobsługiwany typ pliku',
        tooLarge: 'Plik jest za duży (max 10 MB)',
        tooMany: 'Za dużo załączników (max 5)',
        uploadFailed: 'Nie udało się przesłać załącznika',
        deleteFailed: 'Nie udało się usunąć załącznika',
      },
    },
    composer: {
      plus: {
        open: 'Dodaj załącznik lub źródło',
        addFiles: 'Dodaj zdjęcia i pliki',
        connectGithub: 'Połącz GitHub',
        connectGmail: 'Połącz Gmail',
        more: 'Więcej integracji…',
        removeHint: 'Usuń wskazówkę kontekstu',
        providerDisabled: 'Ta integracja nie jest włączona — otwieram ustawienia',
        providers: {
          github: 'GitHub',
          gmail: 'Gmail',
          knowledge: 'Wiedza',
          web: 'Szukaj w sieci',
        },
      },
    },
    blocks: {
      sources: {
        title: 'Źródła',
      },
    },
    memory: {
      title: 'Pamięć',
      subtitle: 'Wspomnienia semantyczne używane przez agenta między sesjami',
      search: 'Szukaj',
      searchPlaceholder: 'Szukaj w pamięci (semantycznie)…',
      searchAction: 'Szukaj',
      semanticHint: 'Wyniki wyszukiwania semantycznego',
      filterScope: 'Zakres',
      add: 'Dodaj wspomnienie',
      addPlaceholder: 'Fakt lub preferencja do zapamiętania…',
      addAction: 'Zapisz',
      loading: 'Ładowanie pamięci…',
      empty: 'Brak wspomnień. Dodaj powyżej lub pozwól agentowi zapisać fakty w czacie.',
      total: '{count} wspomnień',
      saved: 'Zapisano w pamięci',
      saveFailed: 'Nie udało się zapisać',
      updated: 'Zaktualizowano wspomnienie',
      updateFailed: 'Nie udało się zaktualizować',
      deleted: 'Usunięto wspomnienie',
      deleteFailed: 'Nie udało się usunąć',
      edit: 'Edytuj',
      saveEdit: 'Zapisz',
      cancelEdit: 'Anuluj',
      delete: 'Usuń',
      similarity: 'podobieństwo {value}',
      scopes: {
        all: 'Wszystkie zakresy',
        user: 'Użytkownik',
        agent: 'Agent',
        session: 'Sesja',
      },
    },
    knowledge: {
      title: 'Wiedza',
      subtitle: 'Dokumenty dostępne dla agentów przez wyszukiwanie RAG',
      add: 'Dodaj dokument',
      titlePlaceholder: 'Tytuł dokumentu',
      contentPlaceholder: 'Wklej tekst, aby dodać go do bazy wiedzy…',
      addAction: 'Dodaj',
      loading: 'Ładowanie dokumentów…',
      empty: 'Brak dokumentów. Wklej tekst powyżej, aby zacząć.',
      total: '{count} dokumentów',
      chunkCount: '{count} fragmentów',
      added: 'Dokument dodany do kolejki przetwarzania',
      addFailed: 'Nie udało się dodać dokumentu',
      deleted: 'Usunięto dokument',
      deleteFailed: 'Nie udało się usunąć dokumentu',
      preview: 'Podgląd',
      delete: 'Usuń',
      chunkLabel: 'Fragment {index}',
      statuses: {
        pending: 'Przetwarzanie…',
        ready: 'Gotowy',
        failed: 'Błąd',
      },
    },
    wiki: {
      title: 'Wiki',
      subtitle: 'Second Brain — zindeksowana wiedza z folderami, linkami i grafem',
      tabs: {
        pages: 'Strony',
        graph: 'Graf',
      },
      allFolders: 'Wszystkie foldery',
      folders: {
        raw: 'Raw',
        inbox: 'Inbox',
        entities: 'Encje',
        concepts: 'Koncepty',
        summaries: 'Podsumowania',
        meta: 'Meta',
      },
      loading: 'Ładowanie stron wiki…',
      empty: 'Brak stron. Utwórz nową lub użyj przycisku Ingest.',
      total: '{count} stron',
      newPage: 'Nowa strona',
      ingest: 'Ingest',
      pageTitle: 'Tytuł',
      pageBody: 'Treść (Markdown)',
      titlePlaceholder: 'Tytuł strony',
      bodyPlaceholder: 'Napisz treść w Markdown…',
      createAction: 'Utwórz',
      pageCreated: 'Strona utworzona',
      createFailed: 'Nie udało się utworzyć strony',
      delete: 'Usuń',
      deleted: 'Strona usunięta',
      deleteFailed: 'Nie udało się usunąć strony (może być niemutowalna)',
      deprecate: 'Zdeprecjonuj',
      deprecated: 'Strona zdeprecjonowana',
      deprecateFailed: 'Nie udało się zdeprecjonować strony',
      statusDeprecated: 'Zdeprecjonowana',
      confirmDeprecate: 'Zdeprecjonować stronę?',
      confirmDeprecateDesc: 'Strona zostanie oznaczona jako zdeprecjonowana i usunięta z wyników wyszukiwania.',
      cancel: 'Anuluj',
      deprecateAction: 'Zdeprecjonuj',
      ingestTitle: 'Ingest treści',
      ingestTitleLabel: 'Tytuł (opcjonalny)',
      ingestTitlePlaceholder: 'Tytuł dla importowanej treści',
      ingestContentLabel: 'Treść',
      ingestContentPlaceholder: 'Wklej artykuł, dokument lub notatki do importu…',
      ingestAction: 'Importuj',
      ingested: 'Treść zaimportowana do wiki',
      ingestTruncated: 'Treść zaimportowana (ripple obcięty — limit osiągnięty)',
      ingestFailed: 'Nie udało się zaimportować treści',
      searchPlaceholder: 'Szukaj stron…',
      sortBy: 'Sortuj',
      sort: {
        updated_desc: 'Aktualizacja (najnowsze)',
        updated_asc: 'Aktualizacja (najstarsze)',
        created_desc: 'Utworzenie (najnowsze)',
        created_asc: 'Utworzenie (najstarsze)',
        title_asc: 'Tytuł A–Z',
        title_desc: 'Tytuł Z–A',
      },
      selectAll: 'Zaznacz wszystkie',
      selectedCount: 'Zaznaczono: {count}',
      deleteSelected: 'Usuń zaznaczone',
      clearSelection: 'Wyczyść zaznaczenie',
      bulkDeleted: 'Usunięto {count} stron',
      bulkDeleteFailed: 'Nie udało się usunąć zaznaczonych stron',
      confirmBulkDelete: 'Usunąć zaznaczone strony?',
      confirmBulkDeleteDesc: 'Zostanie trwale usuniętych {count} stron. Strony niemutowalne (🔒) zostaną pominięte.',
      purgeAll: 'Wyczyść wszystko',
      purged: 'Usunięto wszystkie strony ({count})',
      purgeFailed: 'Nie udało się wyczyścić wiki',
      confirmPurge: 'Wyczyścić całe wiki?',
      confirmPurgeDesc: 'Spowoduje to trwałe usunięcie WSZYSTKICH stron wiki. Operacja jest nieodwracalna.',
      purgeConfirmLabel: 'Wpisz PURGE, aby potwierdzić',
      outgoingLinks: 'Linki wychodzące',
      incomingLinks: 'Linki przychodzące',
      expandDetail: 'Otwórz w oknie',
      collapseFolders: 'Zwiń foldery',
      expandFolders: 'Rozwiń foldery',
      graphLoading: 'Ładowanie grafu…',
      graphEmpty: 'Brak stron do wyświetlenia w grafie',
      help: {
        newPage: 'Ręcznie utwórz stronę wiki w folderze Inbox',
        ingest: 'Wklej dowolny tekst — AI podzieli go na strony, wyciągnie encje i stworzy podsumowanie',
        deprecate: 'Oznacz stronę jako przestarzałą — zniknie z wyników wyszukiwania agenta',
        delete: 'Trwale usuń stronę (niemożliwe dla stron oznaczonych 🔒)',
        purgeAll: 'Trwale usuń wszystkie strony wiki (nieodwracalne)',
        immutable: 'Strona systemowa — nie można jej usunąć ani edytować',
        howItWorks: 'Jak działa Wiki?',
        howItWorksBody: 'Wiki to Twój Second Brain. Wklejaj treści przez Ingest — AI automatycznie tworzy strony, wyciąga encje i podsumowania. Strony mogą się linkować składnią [[slug]]. Graf pokazuje powiązania. Agent ma dostęp do wiki przy każdym czacie.',
        ingestDialogHint: 'AI przetworzy tekst i stworzy do kilku powiązanych stron w różnych folderach.',
        newPageLinkHint: 'Możesz linkować do innych stron składnią [[slug-strony]].',
        linkPicker: {
          title: 'Wstaw link do strony',
          search: 'Szukaj strony…',
          insert: 'Wstaw link',
          empty: 'Brak pasujących stron',
          hint: 'Kliknij stronę, aby wstawić [[slug]] w miejscu kursora',
        },
        folders: {
          raw: 'Surowa treść zaraz po Ingest, przed przetworzeniem przez AI',
          inbox: 'Strony utworzone ręcznie lub oczekujące na klasyfikację',
          entities: 'Wyodrębnione encje (osoby, firmy, projekty…)',
          concepts: 'Pojęcia i definicje z Twojej wiedzy',
          summaries: 'Streszczenia dokumentów wygenerowane przez AI',
          meta: 'Strony systemowe (indeks, instrukcje dla bibliotekarza)',
        },
      },
    },
    sessions: {
      title: 'Sesje',
      search: 'Szukaj sesji…',
      empty: 'Brak sesji. Rozpocznij nowy czat.',
      noResults: 'Brak pasujących sesji.',
      loadError: 'Nie udało się załadować sesji',
      untitled: 'Czat bez tytułu',
    },
    audit: {
      title: 'Trace uruchomienia',
      description: 'Historia kroków, system prompt i metadane sesji',
      open: 'Audyt',
      openTooltip: 'Audyt uruchomienia',
      trace: 'Trace',
      systemPrompt: 'System prompt',
      session: 'Sesja',
      noRun: 'Wyślij wiadomość, aby zobaczyć audyt',
      noSystemPrompt: 'System prompt będzie dostępny po pierwszej odpowiedzi agenta',
      runId: 'ID runu',
      status: 'Status',
      tokens: 'Tokeny',
      tokensSummary: '{prompt} wejście + {completion} wyjście = {total} łącznie',
      cost: 'Koszt',
      copyRun: 'Kopiuj run',
      copied: 'Run skopiowany do schowka',
      copyFailed: 'Nie udało się skopiować',
    },
    model: {
      selectPlaceholder: 'Wybierz model',
      searchPlaceholder: 'Szukaj modeli…',
      empty: 'Brak modeli pasujących do wyszukiwania.',
      current: 'Model: {name}',
      currentLabel: 'Model',
      defaultModel: 'Domyślny model',
      recommended: 'Polecany',
      price: '{input} wej. / {output} wyj. za 1M',
      context: 'kontekst {size}',
      sortBy: 'Sortuj',
      sort: {
        recommended: 'Polecane',
        power: 'Moc',
        price: 'Cena',
        context: 'Kontekst',
        name: 'Nazwa',
      },
      tier: {
        frontier: 'Topowy',
        balanced: 'Zrównoważony',
        fast: 'Szybki',
      },
      feature: {
        vision: 'Wejście obrazu',
        tools: 'Wywoływanie narzędzi',
        reasoning: 'Rozszerzone rozumowanie',
      },
      browseAll: 'Przeglądaj wszystkie',
      showingOf: '{shown} z {total}',
      results: 'Modele: {count}',
      filters: {
        capabilities: 'Możliwości',
        requireVision: 'Wejście obrazu',
        requireTools: 'Wywoływanie narzędzi',
        requireReasoning: 'Rozszerzone rozumowanie',
        recommendedOnly: 'Tylko rekomendowane',
        maxOutputCost: 'Maks. koszt wyjścia',
        minContext: 'Min. kontekst',
        providers: 'Dostawcy',
        noLimit: 'Dowolny',
        reset: 'Resetuj filtry',
      },
    },
    settings: {
      subtitle: 'Konfiguracja agenta i integracji produktowych',
      models: 'Modele',
      modelsDescription: 'Wybierz domyślny model używany w czacie',
      modelsHint: 'Zmiana dotyczy nowych wiadomości. Administrator workspace może ograniczyć listę modeli.',
      integrations: 'Integracje',
      integrationsDescription: 'Połącz GitHub, Jira i GitLab z agentem workspace',
      backToChat: 'Wróć do czatu',
    },
  },
}
